import { render } from "./ShadeGrouping.vue?vue&type=template&id=4365d94a&scoped=true&ts=true"
import script from "./ShadeGrouping.vue?vue&type=script&lang=ts"
export * from "./ShadeGrouping.vue?vue&type=script&lang=ts"

import "./ShadeGrouping.vue?vue&type=style&index=0&id=4365d94a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4365d94a"]])

export default __exports__